// DraggableListItem.jsx (MUI v7+ compatible)
import { Draggable } from 'react-beautiful-dnd';
import ListItem from '@mui/material/ListItem';
import { css } from '@emotion/react'; // use Emotion to generate classNames
import ColorConstants from '../../defaults/ColorConstants';
import { getListCard } from '../../utils/ListCardHelper';
import FieldNames from '../../defaults/FieldNames.json';

// Replace makeStyles rules with Emotion classNames
const saveSpace = css({
  paddingTop: '0px!important',
});

const saveSpaceCarryover = css({
  paddingTop: '0px!important',
  backgroundColor: ColorConstants.CarryOver,
});

// Use sx for component styles (no JSS)
const baseItemSx = {
  width: '550px',
  height: '300px',
  maxHeight: '300px',
};

const draggingItemSx = {
  ...baseItemSx,
  background: 'rgb(235,235,235)',
};

const DraggableListItem = ({ style, selectedFeature, index, handleRemoval, isDraggable }) => {
  if (!selectedFeature || !selectedFeature.ID) return '';

  const isCarryover =
    selectedFeature[FieldNames.featureFields.isCarryover] === FieldNames.yesNo.yes;

  const backgroundClass = isCarryover ? saveSpaceCarryover : saveSpace;

  // Keep your cardStyles shape the same (helper expects class names)
  const cardStyles = {
    styleHeight: style?.height ? style.height - 5 : 165,
    styleWidth: style?.width ? style.width : '550px',
    cardSizes: FieldNames.listCardTypes.detailed,
    arrowListCard: 'list-normal',
    backgroundClassListCard: backgroundClass,
    classesListCard: saveSpace,
    backgroundClass: saveSpace,
  };

  const conditionalItems = {
    objectId: null,
    onClicked: handleRemoval,
    selectedFeatures: [],
    selectFeature: null,
    createActual: null,
    reportActual: null,
    isGroupingsLoading: false,
    onGroupEdit: null,
  };

  return (
    <Draggable draggableId={String(selectedFeature.ID)} index={index}>
      {(provided, snapshot) => {
        // Merge RBD's provided style with any inbound style
        const mergedStyle = {
          ...(provided.draggableProps.style || {}),
          ...(style || {}),
        };

        return (
          <ListItem
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            component="div"
            sx={snapshot.isDragging ? draggingItemSx : baseItemSx}
            style={mergedStyle}
          >
            {getListCard(
              index,
              selectedFeature,
              isDraggable,
              cardStyles,
              conditionalItems
            )}
          </ListItem>
        );
      }}
    </Draggable>
  );
};

export default DraggableListItem;
